import React from "react";
import { Box, Stack } from "@mui/material";
import { useRouter } from "next/router";
import { SidebarItemButton } from "./components";
import { SidebarBase } from "./components/SidebarBase";
import { SidebarHeader } from "./components/SidebarHeader";
import { SidebarDivider } from "./components/SidebarDivider";
import { SidebarIconButton } from "./components/SidebarIconButton";
import { SidebarProfileSection } from "./components/SidebarProfileSection";
import { SidebarLocaleToggle } from "./components/SidebarLocaleToggle";
import { SidebarSectionLabel } from "./components/SidebarSectionLabel";
import { Icon } from "../Icon";

export type ProjectSideBarItem = {
  id: string;
  icon: React.ReactNode;
  disabled?: boolean;
  /** 비활성인 까닭 — 툴팁과 접근 설명으로 밝힌다(`SidebarItemButton` 의 `disabledReason`). 활성이면 쓰이지 않는다. */
  disabledReason?: string;
  onClick?: () => void;
};

/**
 * 단순 목록 사이드바 props — 프로젝트 목록 페이지용. 2D/3D 토글이나 패널 펼침은 없다.
 * 풀 기능이 필요하면 {@link ApplicationSideBar} 를 쓴다.
 */
export type ProjectSideBarProps = {
  name: string;
  profileMode?: "off" | "on" | "disabled";
  items: ProjectSideBarItem[];
  onHomeClick?: () => void;
};

export function ProjectSideBar({
  name,
  profileMode = "off",
  items,
  onHomeClick,
}: ProjectSideBarProps) {
  const router = useRouter();

  return (
    <SidebarBase>
      <SidebarHeader onHomeClick={onHomeClick} />
      <Box
        sx={{
          padding: "12px 0",
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <SidebarItemButton
          mode="on"
          icon={{
            component: <Icon name="24/nav/basic/project" size={20} clickable />,
            name: "PROJ",
          }}
          onClick={() => router.reload()}
        />
      </Box>
      <SidebarDivider />
      <SidebarSectionLabel>APP</SidebarSectionLabel>
      <Stack
        direction="column"
        spacing={1.5}
        alignItems="center"
        sx={{ flexGrow: 1 }}
      >
        {items.map((item) => (
          <SidebarItemButton
            key={item.id}
            icon={{
              component: item.icon,
              name: item.id,
            }}
            onClick={item.onClick}
            disabled={item.disabled}
            disabledReason={item.disabledReason}
          />
        ))}
      </Stack>
      <Stack direction="column" spacing={1} alignItems="center" sx={{ mb: 2 }}>
        <SidebarIconButton
          opacity={0.5}
          icon={<Icon name="24/nav/basic/manual" size={24} clickable />}
          onClick={() => window.open("/manual", "_blank")}
        />
        <SidebarLocaleToggle />
      </Stack>
      <SidebarDivider variant="thick" />
      <SidebarProfileSection name={name} profileMode={profileMode} />
    </SidebarBase>
  );
}
